import React from "react";
import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { CMSPath } from "../../../config/constant";
import { connect } from "react-redux";
import moment from "moment";
import { formatDateAsDateFormat } from "./spaBooking3";
import { formatMinutesToTimeFormat, toBool } from "../../JS/utility";
import { scrollToTop } from "../../../JS/scrollToTop";



function SpaBooking3c(props) {
  const { t } = props;




  function getAllTechnician() {
    const availableTechnician = [];

    //note : spaSearchAvail giving time as string is -4GMT, and when we do new Date(date), it convert to local time, so possiblity of gmt change, hence don't do
    // hence use moment instead;
    props.technicianAvailableData.forEach((data) => {



      const dateAvailable_ = data.availableDate.split('T')[0];
      const startTime = data.startTime;
      data.results.forEach((d) => {
        availableTechnician.push({
          technicianId: d.technicianId,
          technicianName: d.technicianName || (d.technician && d.technician.fullNameDisplayed) || `${d.technician.firstName ? d.technician.firstName : ''} ${d.technician.lastName ? d.technician.lastName : ''}`,
          availableDate: dateAvailable_,
          startTime: startTime,
          technicianPrice: d.technician.price
        });
      });
    });
    return availableTechnician;
  }

  const handleBack = () => {
    props.goBack();
  };

  useEffect(() => {
    console.log(getAllTechnician(), "getAllTechnician");
    scrollToTop()
  }, []);



  return (
    <>
      <section class="widgets spa-listing spa-details time-selection">
        <div class="widget-header">
          {props.currentWidgetObj.widgetHeaderImageUrl && (
            <div class="widget-header-img">
              <img
                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                alt={props.currentWidgetObj.displayName}
              />
            </div>
          )}
          <div class="widget-header-title">{t(`spaBooking.heading3c`)}</div>
        </div>

        <div class="widgets">
          <div class="row margin-bottom-2">
            <div class="row">
              <div class="col">
                <div class="detail-body stay-body">
                  <form>
                    <div class="form-row">
                      <p class="heading">{t(`spaBooking.available_time`)}</p>
                      <div class="form-options">
                        {getAllTechnician().map((technician) => {
                          return (
 
                            <label>
                              <input
                                type="radio"
                                name="Times"
                                value={JSON.stringify(technician)}
                                checked={
                                  JSON.stringify(
                                    props.selectedTechnicianDetails
                                  ) == JSON.stringify(technician)
                                }
                                onChange={(e) => {
                                  console.log('log e', e)
                                  console.log(JSON.parse(e.target.value));
                                  props.setSelectedTechnicianDetails(
                                    JSON.parse(e.target.value)
                                  );
                                }}
                              />
                                
                                  {` ${formatMinutesToTimeFormat(technician.startTime, toBool(props.timeFormat))}`}
                                  <span className="spa-technician_name">-{technician.technicianName}</span>
                                {/* <span class="amount">{`${props.currencyCode} ${technician.technicianPrice}`}</span> */}
                                 
                              
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-controls">
                <button
                  disabled={!props.selectedTechnicianDetails}
                  onClick={() =>
                    props.handleNextToAdditionalInfo(
                      props.selectedTechnicianDetails
                    )
                  }
                >
                  {t(`spaBooking.continue`)}
                </button>
                <button onClick={handleBack}>{t(`spaBooking.back`)}</button>
              </div>
            </div>
          </div>
        </div>
      </section>


    </>
  );
}

const mapStateToProps = state => {
  return {
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
    timeFormat: state.store.home.clientConfig.extraConfigParam && state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    currencyCode: state.store.home.clientConfig.currencyDetails
      ? state.store.home.clientConfig.currencyDetails.code
      : ""

  }
}
export default connect(mapStateToProps)(withTranslation("translations")(SpaBooking3c))



//   ${ moment(technician.availableDate).format((props.dateFormat).toUpperCase()) } - 
